const Blob = () => {
    class NaturalBlob {
        constructor(svg) {
            this.path = svg.querySelector('path');
            this.points = 10 + Math.floor(Math.random() * 6); // mniej punktów = mniej obłości
            this.baseRadius = 90;
            this.amplitude = 15;
            this.speed = 0.001;
            this.phase = Array.from({
                length: this.points
            }, () => Math.random() * Math.PI * 2);
            this.timeOffset = Math.random() * 10000;
            this.animate(0);
        }

        getPoints(time) {
            const pts = [];
            const step = (Math.PI * 2) / this.points;

            for (let i = 0; i < this.points; i++) {
                const angle = i * step;
                const r =
                    this.baseRadius + Math.sin(time * this.speed + this.phase[i]) * this.amplitude;
                const x = 100 + Math.cos(angle) * r;
                const y = 100 + Math.sin(angle) * r;
                pts.push({
                    x,
                    y
                });
            }

            return pts;
        }

        smoothPath(points) {
            let d = '';
            const len = points.length;

            // Zacznij od środka między ostatnim a pierwszym punktem (płynne zamknięcie)
            const startMid = {
                x: (points[len - 1].x + points[0].x) / 2,
                y: (points[len - 1].y + points[0].y) / 2
            };

            d += `M ${startMid.x} ${startMid.y} `;

            // Gładkie krzywe między środkami kolejnych punktów
            for (let i = 0; i < len; i++) {
                const next = (i + 1) % len;
                const mid = {
                    x: (points[i].x + points[next].x) / 2,
                    y: (points[i].y + points[next].y) / 2
                };
                d += `Q ${points[i].x} ${points[i].y} ${mid.x} ${mid.y} `;
            }

            d += 'Z';
            return d;
        }

        animate(time) {
            const pts = this.getPoints(time);
            const d = this.smoothPath(pts);
            this.path.setAttribute('d', d);
            requestAnimationFrame((t) => this.animate(t));
        }
    }

    document.querySelectorAll('.blob').forEach(svg => new NaturalBlob(svg));
}

export default Blob;